/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { SlideImageViewModel } from "../types/SlideImageViewModel.ts";

export const slideImageViewModelSchema = z.object({
  index: z.optional(z.number().int()),
  url: z.string().nullish(),
}) as unknown as ToZod<SlideImageViewModel>;
